// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VJDz","toggle":"styles_toggle__3bGqy","preview":"styles_preview__3OgyV"};